export class SafetyPointFormModel {
    public SafetyPointFormId: number = 0;    
    public TodoId: number = 0;  
    public CompletedFormId : number = 0;
    public SafetyPointId: number = 0;
    public MitarbeiterId: number | null= null;
    public Datum: Date| null= null;    
    public AdminNotizen: string | null= null;
    public Status : number | null=null;    
    public ZurueckgewiesenVon: number | null= null;
    
}

export interface SafetyPointFormModelView {
    SafetyPointFormId: number
    TodoId: number  
    CompletedFormId : number
    SafetyPointId: number
    MitarbeiterId: number
    Datum: Date    
    AdminNotizen: string
    Status : number    
    ZurueckgewiesenVon: number
    DeletedOn: Date
    Termin?: Date
    FormularBezeichnung: string
    StepList: []
    Signature: boolean
    SafetyPointBezeichnung: string
    ObjektID: number
    RoofareaID: number
    UserID: number
    CreatedOn : Date;
}